import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-text-link-container',
  template: `
    <div class="text-link-container">
      <ng-content></ng-content>
    </div>
  `,
  styles: `
    .text-link-container {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    ::ng-deep .text-link-container > *:not(:last-child)::after {
      content: '•';
      margin: 0 var(--item-spacing-between-md);
      color: var(--col-text-tertiary);
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TextLinkContainerComponent {}
